
import React, { useEffect, useState } from 'react';
import { DynamicSelect } from '../components/_DynamicSelect';
import { Select } from 'antd';


type Props = {
    messageId: number[];
    leadsForRelations: any[];
    userForRelations: any[];
    setToSelectedTarget: Function;
    closePopup: Function;
};
const SetMessageTo_Popup = (props: Props) => {
    const [selectedLeadId, setSelectedLeadId] = useState<string>('');
    const [selectedLead, setSelectedLead] = useState<string>('');
    const [selectOptions, setSelectOptions] = useState<any[]>([]);
    const [disableButton, setDisabledButton] = useState<boolean>(false)

    useEffect (()=>{
        const records = props.leadsForRelations.sort((a: any, b: any) => {
            
            if (a.label.trim() < b.label.trim()) {
                return -1;
            }
            if (a.label.trim() > b.label.trim()) {
                return 1;
            }
            return 0;
        })
        setSelectOptions(records)
    },[]);

    const closePopup = () => {
        props.closePopup();
    }

    const onSelectLead = (leadId: string) => {
        const selectedValue = leadId;
        // console.log(selectedValue)
        setSelectedLeadId(selectedValue);
        // const selectedOption = selectOptions.find((o: any) => o.val == selectedValue)
        // setSelectedLead()
    }

    const onFilter = (inputValue: string, option: any) => {
        return (
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
        );
    }


    const setToSelectedTarget = () => {
        setDisabledButton(true);
        props.setToSelectedTarget(props.messageId, 'lead', selectedLeadId);
    }



    return (
    <div className="popup-wrapper">
        <section className="popup-window one-input move-to-folder rtl">
        <div className="close-icon pointer" onClick={(e:any)=>closePopup()}>
            <div className="popup-title"></div>
        </div>
        <div className="popup-content">
            <div className="popup-header">
                הוספת טיפול שוטף   
            </div>
            <div>
            ליד
            </div>
            <div className="popup-body">
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value">
                                {/* <DynamicSelect ClassName="" OnChange={onSelectLead} Value={selectedLeadId} Options={
                                    selectOptions.map(
                                        (f: any)=>(
                                            {
                                                Text: f.label,
                                                Value: f.val})
                                    )
                                } Id={"selectFolder"} /> */}
                                
                                <Select
                                    allowClear
                                    showSearch
                                    filterOption={onFilter}
                                    style={{ width: '100%' }}
                                    placeholder="נא לבחור מיגון"
                                    defaultValue={selectedLeadId}
                                    onChange={onSelectLead}
                                    options={selectOptions.map(
                                            (item: any)=>({label: item.label, value: item.val}))}
                                />
                                
                                {/* <input type='text'
                                    list="folder_list"
                                    onChange={onSelectLead}
                                    value={selectedLead} 
                                />
                                <datalist id="folder_list">
                                    {selectOptions.map((o:any, i)=><option key={i} value={o.val}>{o.label}</option>)}
                                </datalist> */}
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div className="popup-footer">
                {
                    !disableButton ? (
                <button className="button blue" onClick={(e:any)=>setToSelectedTarget()}>
                    אישור
                </button>

                    ) : (<></>)
                }
            </div>
        </div>
        </section>
    </div>
    )
}

export default SetMessageTo_Popup;